import React, { useState, useEffect } from 'react';
import GoogleMapReact from "google-map-react";
import './styles.css';

// Marcador do mapa
const MarkerComponent = ({ finalizado, lat, lng }: any) => {
  const classMarker = finalizado ? 'marker-success' : 'marker-warning';
  return <div className={classMarker}></div>
}

interface TypeProps {
  data: any[]
}

export default function WidgetMap({ data }: TypeProps) {

  const [currentLat, setCurrentLat] = useState<number>(-23.8863672);
  const [currentLong, setCurrentLong] = useState<number>(-46.9771151);

  useEffect(() => {
    //localização atual do usuario logado
    navigator.geolocation.getCurrentPosition(function (position) {
      const { latitude, longitude } = position.coords;
      setCurrentLat(latitude)
      setCurrentLong(longitude)
    })
  }, [])


  return (
    <div id="container-widget-map">
      {/*
      <div id='container-widget-map-infos'>
        <h1>Regiões com mais registros</h1>
        <span id='container-widget-map-infos-total'>1578</span>
        <span id='container-widget-map-infos-city'>São Paulo</span>
      </div>
      */}
      <div id='container-widget-map-locations'>
        {data &&
          <GoogleMapReact
            bootstrapURLKeys={{ key: process.env.REACT_APP_API_GOOGLE || '' }}
            defaultCenter={{
              lat: currentLat,
              lng: currentLong,
            }}
            defaultZoom={8}
          >
            {data.map((i, index) =>
              <MarkerComponent
                key={index}
                finalizado={i.finalizado}
                lat={i.location?.geometry?.location?.lat || null}
                lng={i.location?.geometry?.location?.lng || null}
              />
            )}
          </GoogleMapReact>
        }
      </div>
    </div>
  )
}
